module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/speaker-regular.b8ce5f3.png";